import styled from 'styled-components'

export const Number = styled.div`
	font-weight: 600;
`
